import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../context/userContext';
import { Box, Toolbar, ListItemButton, ListItemText, AppBar } from '@mui/material';
import { logout } from '../api/axios';
import {ReactComponent as OliIcon} from '../static/icons/Algo Olio.svg';
import {ReactComponent as LogoutIcon} from '../static/icons/Log Out.svg';

const TopNavbar = () => {
  const navigate = useNavigate();
  const { contextLogout, user } = useUser();
  
  const isPremium = user && user.data.planType === 'Premium';
  
  const handleNavigation = (path) => {
    navigate(path);
  };

  const handleLogoutClick = () => {
    logout();
    contextLogout();
    navigate('/login', {replace: true});
  };

  return (
    <AppBar
      position="static"
      sx={{
        width: '100%',
        height: '9.5%',
        background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%), linear-gradient(326deg, #A29EDA -46.9%, #916CB4 -29.33%, #8E3A88 27.57%, #6B3A8F 73.58%, #5D2A79 115.7%)',
        boxShadow: 'none',
        zIndex:5
      }}
    >
      <Toolbar sx={{ 
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 30px',
        height: '100%'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <OliIcon width='60' height='60' style={{ marginRight: '30px' }}/>
          
          <Box sx={{ display: 'flex' }}>
            <ListItemButton 
              onClick={() => handleNavigation('/dashboard')} 
              sx={{
                color: 'white',
                fontSize: '16px',
                paddingX: '24px'
              }}
            >
              <ListItemText primary="Dashboard" />
            </ListItemButton>
            
            <ListItemButton 
              onClick={() => handleNavigation('/courses')} 
              sx={{
                color: 'white',
                fontSize: '16px',
                paddingX: '24px'
              }}
            >
              <ListItemText primary="Courses" />
            </ListItemButton>
            
            {isPremium && (
              <>
                <ListItemButton 
                  onClick={() => handleNavigation('/resume/upload')} 
                  sx={{
                    color: 'white',
                    fontSize: '16px',
                    paddingX: '24px'
                  }}
                >
                  <ListItemText primary="Resume Checker" />
                </ListItemButton>
                
                <ListItemButton 
                  onClick={() => handleNavigation('/interview-start-page')} 
                  sx={{
                    color: 'white',
                    fontSize: '16px',
                    paddingX: '24px'
                  }}
                >
                  <ListItemText primary="Virtual Interviewer" />
                </ListItemButton>
              </>
            )}
          </Box>
        </Box>
        
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ListItemButton 
            onClick={handleLogoutClick}
            sx={{
              color: 'white',
              paddingX: '16px',
              display: 'flex',
              alignItems: 'center',
              gap: '10px',
              height: '100%'
            }}
          >
            <LogoutIcon style={{ marginRight: '10px' }} />
            <span style={{ 
              color: '#FFF', 
              fontFamily: 'Poppins', 
              fontSize: '16px', 
              fontWeight: 500,
              lineHeight: 1.5 
            }}>
              Log Out
            </span>
          </ListItemButton>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNavbar;